import { Component } from '@angular/core';
import {SharedMarcacaoService} from "../../services/shared-marcacao.service";
import {ItensAtendimentoModel} from "../../models/itens-atendimento.model";

@Component({
  selector: 'app-procedimentos',
  templateUrl: './procedimentos.component.html',
  styleUrls: ['./procedimentos.component.scss']
})
export class ProcedimentosComponent {
  protected itensAtendimento: ItensAtendimentoModel[] = [];

  constructor(private sharedMarcacaoService: SharedMarcacaoService) { }

  ngOnInit() {
    this.sharedMarcacaoService.marcacaoAtual.subscribe(marcacao => {
      this.itensAtendimento = marcacao?.atendimento?.itensAtendimento ?? [];
    });
  }
}
